/**
 * @public
 * @deprecated use `next-sanity/live` instead
 */
export function defineLive(): void {
  throw new Error('defineLive is now part of next-sanity/live and @sanity/next-loader is retired')
}
